/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { FILE_STATUS, LESSON_DETAIL_TYPE } from '../../../constants'
import { useCourseDetail, useHistories, useProfile, useUnitLesson } from '../../../hooks'
import { LessonPDF, LessonSlide, LessonVideo } from '../components'
import { STORAGE, setLocalStorage } from '../../../utils'
import Modal from '../../../components/modal'
import useQuery from '../../../hooks/useQuery'

export const NoticeWrapper = styled.p`
  font-size: 20px;
  font-weight: 700;
`

const CourseLessonScreen = () => {
  const { t } = useTranslation()
  const { courseId, lessonId } = useParams()
  const { profile } = useProfile()
  const query = useQuery()
  const fromTab = query.get('fromTab')
  const history = useHistories()

  const { pathname } = useLocation()

  const { lessonDetail, submitLesson, isLoadDataSuccess, isSubmitEnd, createHistoryAction, historyId, getDateCompleteTimeAction } = useUnitLesson({
    userId: profile.userId,
    courseId,
    lessonId,
    isCreateHistory: false
  })

  useEffect(() => {
    getDateCompleteTimeAction({
      callback: {
        done: (data) => {
          setLocalStorage(STORAGE.DATE_COMPLETE_TIME, JSON.stringify(data))
        }
      }
    })
  }, [])

  const { courseDetail, loadCourseDetail, countViewUnit, isRequestPasswordVideo, requestPasswordVideoAction, isLoading } = useCourseDetail({
    userId: profile.userId,
    courseId
  })

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  useEffect(() => {
    if (isLoadDataSuccess) {
      loadCourseDetail()
    }
  }, [isLoadDataSuccess])

  useEffect(() => {
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault()
    })
    document.onkeydown = (e) => {
      if (e.keyCode === 123) {
        return false
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode === 'I'.charCodeAt(0)) {
        return false
      }
      if (e.metaKey && e.altKey && e.keyCode === 'I'.charCodeAt(0)) {
        return false
      }
      if (e.metaKey && e.altKey && e.keyCode === 'U'.charCodeAt(0)) {
        return false
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode === 'C'.charCodeAt(0)) {
        return false
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode === 'J'.charCodeAt(0)) {
        return false
      }
      if (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0)) {
        return false
      }
      return true
    }
  }, [])

  const renderLesson = (currentLesson) => {
    switch (currentLesson) {
      case LESSON_DETAIL_TYPE.VIDEO: return (
        <LessonVideo
          courseDetail={courseDetail}
          lessonDetail={lessonDetail}
          submitLesson={submitLesson}
          countViewUnit={countViewUnit}
          courseId={courseId}
          lessonId={lessonId}
          isLoading={isLoading}
        />
      )
      case LESSON_DETAIL_TYPE.PDF: return (
        <LessonPDF
          courseDetail={courseDetail}
          lessonDetail={lessonDetail}
          submitLesson={submitLesson}
          countViewUnit={countViewUnit}
          historyId={historyId}
          courseId={courseId}
          lessonId={lessonId}
          isLoading={isLoading}
        />
      )
      case LESSON_DETAIL_TYPE.PPT: return (
        <LessonSlide
          courseDetail={courseDetail}
          lessonDetail={lessonDetail}
          submitLesson={submitLesson}
          isSubmitEnd={isSubmitEnd}
          countViewUnit={countViewUnit}
          historyId={historyId}
          courseId={courseId}
          lessonId={lessonId}
          isLoading={isLoading}
        />
      )
      default: return (
        <LessonVideo
          courseDetail={courseDetail}
          lessonDetail={lessonDetail}
          submitLesson={submitLesson}
          countViewUnit={countViewUnit}
          createHistory={createHistoryAction}
          courseId={courseId}
          lessonId={lessonId}
          isLoading={isLoading}
        />
      )
    }
  }

  const renderModal = () => (
    <Modal
      isModalVisible
      okText={t('common.ok')}
      isCancel={false}
      width="30vw"
      hideModalWhenSubmit={false}
      onOk={() => history.push(`/course/detail/${courseId}?fromTab=${fromTab}`)}
    >
      <NoticeWrapper>{t('course_detail.deleted_file_notice')}</NoticeWrapper>
    </Modal>
  )

  return (
    <div>
      {!!lessonDetail.type && renderLesson(lessonDetail.type)}
      {lessonDetail?.fileStatus === FILE_STATUS.DELETED && renderModal()}
    </div>
  )
}
export default CourseLessonScreen
